/**
 * "vor 5 Min.", "vor 3 Std.", then a date. For moments in the PAST only —
 * when the last sync ran, not when the next one will. Coarse on purpose: the
 * reader wants to know whether the data is fresh, not to the minute how old.
 */
export function relativeTime(iso: string): string {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000)
  if (minutes < 2) return 'gerade eben'
  if (minutes < 60) return `vor ${minutes} Min.`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `vor ${hours} Std.`
  return `am ${new Date(iso).toLocaleDateString('de-DE')}`
}
